"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var className = function className(props) {
  return (0, _classnames.default)('Tag', {
    'Tag--brand': props.color === 'brand',
    'Tag--red': props.color === 'red',
    'Tag--green': props.color === 'green',
    'Tag--yellow': props.color === 'yellow',
    'Tag--blue': props.color === 'blue',
    'Tag--orange': props.color === 'orange'
  }, props.className);
};

var Tag = function Tag(props) {
  var children = props.children,
      style = props.style;
  return _react.default.createElement("div", {
    className: className(props),
    style: style
  }, children);
};

var _default = Tag;
exports.default = _default;